// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const API_BASE = 'https://crtapp.xyz';

function ProtectedRoute({ children, requiredRole }) {
  const [status, setStatus] = useState('checking');
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/check-auth`, {
      credentials: 'include'
    })
      .then(async (res) => {
        if (!res.ok) throw new Error('Not authenticated');
        return res.json();
      })
      .then((data) => {
        const authenticatedUser = { role: data.role };
        sessionStorage.setItem('user', JSON.stringify(authenticatedUser));
        setUser(authenticatedUser);
        setStatus('authenticated');
      })
      .catch(() => {
        sessionStorage.removeItem('user');
        setStatus('unauthenticated');
      });
  }, []);

  if (status === 'checking') {
    return <p>Loading...</p>;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;